import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '@/views/Login.vue'
import Register from '@/views/Register.vue'
import PhotoTagging from '@/views/PhotoTagging.vue'
import QualityControl from '@/views/QualityControl.vue'
import PasswordReset from '@/views/PasswordReset.vue'
import PasswordChange from '@/views/PasswordChange.vue'
import ManageTags from '@/views/ManageTags.vue'
import ManageUsers from '@/views/ManageUsers'
import store from '@/store/index.js'
import QueryPhotos from "@/views/QueryPhotos.vue";
import energizerPhotoTagging from "@/components/energizerPhotoTagging.vue";


const routes = [
    {path: '/login', name: 'login', component: Login},
    {path: '/register', name: 'register', component: Register},
    {path: '/tagging', name: 'tagging', component: PhotoTagging},
    {path: '/password-reset', name: 'password-reset', component: PasswordReset},
    {path: '/password-change/:token', name: 'password-change', component: PasswordChange},
    {path: '/quality-control', name: 'quality-control', component: QualityControl},
    {path: '/manage-tags', name: 'manage-tags', component: ManageTags},
    {path: '/manage-users', name: 'manage-users', component: ManageUsers},
    {path: '/query-photos', name: 'query-photos', component: QueryPhotos},
    {path: '/tagging/?response_id=:response_id', name: 'augmentedTagging', component: PhotoTagging}
]

Vue.use(VueRouter)
const router = new VueRouter({
    scrollBehavior() {
        return {x: 0, y: 0}
    },
    mode: 'history',
    routes
})

const authExcludedRoutes = [
    //Include Routes that SHOULD NOT check for authorization here
    'login',
    'register',
    'password-reset',
    'password-change'

]

router.beforeEach((to, from, next) => {

    if (store.state.auth.loggedIn) {


        if (!store.state.auth.profile.user.roles.includes('Tagger') && to.name === 'tagging') {
            next('/')
        }

        if (!store.state.auth.profile.user.roles.includes('Sys Admin') && to.name === 'manage-tags') {
            next('/')
        }


        if (!store.state.auth.profile.user.roles.includes('Quality Control') && to.name === 'quality-control') {
            next('/')
        }

        if (!store.state.auth.profile.user.roles.includes('Auth Admin') && to.name === 'manage-users') {
            next('/')
        }
    }

    if (store.state.auth.loggedIn === false && !authExcludedRoutes.includes(to.name)) {
        next('/login')
    } else {
        next()
    }
})

export default router
